import { useTranslation } from 'react-i18next';
import { JobType } from '@tiendanube/common';
import { Domain as DomainEnum } from '@tiendanube/common/src/enums';
import { Alert } from '@tiendanube/components';
import { useBackgroundJobs } from 'App/settings/jobs/hooks';

function AlertMassAction({
  keyPrefix,
  jobId,
}: {
  keyPrefix: string;
  jobId: JobType;
}): JSX.Element | null {
  const { t } = useTranslation(DomainEnum.CATALOG, {
    keyPrefix,
  });
  const { jobStatus, removeJob } = useBackgroundJobs(jobId);

  const title = {
    pending: t('loadingTitle'),
    ready: t('successTitle'),
    failed: t('errorTitle'),
  }[jobStatus];

  const description = {
    pending: t('loadingText'),
    ready: null,
    failed: null,
  }[jobStatus];

  const appearance = {
    pending: 'primary',
    ready: 'success',
    failed: 'danger',
  }[jobStatus];

  const handleDismiss = jobStatus !== 'pending' ? removeJob : undefined;

  const handleShow = jobStatus && jobStatus !== 'idle';

  return (
    <Alert
      title={title}
      appearance={appearance}
      onDismiss={handleDismiss}
      show={handleShow}
    >
      {description}
    </Alert>
  );
}
export default AlertMassAction;
